import React from "react"

// Img
import imgFujita from "../../assets/img/logo_fujita.png"

const LogoFujita = () => {
  return <img src={imgFujita} alt="'高'環境づくりフジタ" />
}

export default LogoFujita